import type { Versjon } from '@/generated/nvdb/datakatalog/models';
import { ServerStatusResponse } from '../responses';

type ServerStatusApiResponse = {
    datagrunnlag: {
        datakatalog: Versjon;
        sist_prosesserte_transaksjon: {
            transaksjonstidspunkt: string;
        };
    };
};

export function transformServerStatus(
    data: ServerStatusApiResponse
): ServerStatusResponse {
    const datagrunnlag = data['datagrunnlag'];
    const { dato, id, versjon } = datagrunnlag.datakatalog;
    return new ServerStatusResponse(
        datagrunnlag.sist_prosesserte_transaksjon.transaksjonstidspunkt,
        {
            dato,
            id,
            versjon,
        }
    );
}
